<template>
    <div class="community-wrapper">
        <!-- 公开到社区 -->
        <div class="community-tip">
            <i class="iconfont icon-tishi info-icon"></i>
            <p>
                {{
                    props.scope === 'community_open'
                        ? '该资源将公开到目标网站，所有人可见'
                        : '该资源将存放在目标网站个人资源中，仅自己可见'
                }}
            </p>
        </div>
        <el-form
            v-if="props.scope === 'community_open'"
            ref="formRef"
            :model="formData"
            label-width="80px"
            class="community-form"
            v-loading="loading"
            label-position ='left'
        >
            <!-- 资源类型 -->
            <div class="category-checkbox">
                <el-form-item
                    label="资源类型："
                    prop="categoryId"
                    class="entire-line-item form-item-nomarginbottom"
                    label-width="94px"
                >
                    <el-checkbox-group v-model="formData.categoryId">
                        <template
                            v-for="i in communityConfigData"
                            :key="i.categoryCode"
                        >
                            <el-checkbox
                                :label="i.categoryCode"
                                class="srt-el-checkbox"
                                >{{ i.categoryName }}</el-checkbox
                            >
                        </template>
                    </el-checkbox-group>
                </el-form-item>
            </div>
            <!--  -->
            <div
                :class="['model-form-con', {'overflow-model-form': isOverflow}]"
            >
                <template
                    v-for="i in communityConfigData"
                    :key="i.categoryCode"
                >
                    <ComponentFormItem
                        v-if="formData.categoryId.includes(i.categoryCode)"
                        ref="categoryFormRef"
                        :categoryName="i.categoryName"
                        :categoryCode="i.categoryCode"
                        :options="i.subCategoryList"
                        :brand="props.brand"
                        :tenant="props.tenant"
                    ></ComponentFormItem>
                </template>
            </div>
        </el-form>
        <div class="btn-con" v-if="showConfirmButton">
            <el-button
                class="srt-el-button srt-el-button--cancel srt-el-button-h36"
                @click="handleCancel"
                >取消
            </el-button>
            <el-button
                type="primary"
                class="srt-el-button srt-el-button--primary srt-el-button-h36"
                :disabled="formData.categoryId.length === 0"
                @click="handleConfirm"
                >确定</el-button
            >
        </div>
    </div>
</template>

<script setup lang="ts">
import {reactive, ref, watch, onMounted, computed} from 'vue';
import ComponentFormItem from './ComponentFormItem.vue';
import Message from '@/components/message/message.js';
type ICategoryList = {
    firstCategoryCode: string;
    chooseCategoryOptionList: [];
    // delayOpenTimeDuration?: string;
    visibleTime: number;
}[];

const props = withDefaults(
    defineProps<{
        id: number | string;
        tenant: string;
        brand: string;
        scope: string;
        visible: boolean;
        isOverflow?: boolean;
        showConfirmButton?: boolean;
    }>(),
    {
        id: undefined,
        tenant: '',
        brand: '',
        scope: 'community_open',
        visible: false,
        isOverflow: true,
        showConfirmButton: true
    }
);
defineExpose<{
    getParams:() => Promise<{
        chooseCategoryList: ICategoryList;
        // delayOpenTimeDuration: string | number;
        // delayOpenTimeUnit: string;
        visibleTime: number;
    }>;
}>({getParams});
const emit = defineEmits(['success', 'cancel']);

const loading = ref(false);
const categoryFormRef = ref([]);
const formRef = ref();
const formData = ref<{categoryId: string[]}>({categoryId: []});
const communityConfigData = ref<any[]>([]);

onMounted(() => {
    console.log('push dialog form mounted');
    getCommunityAssetCategory();
});

async function getParams() {
    // 外侧选择的是私有时。直接返回默认值不验证
    if (!formRef.value) {
        return {
            chooseCategoryList: [],
            // delayOpenTimeDuration: 6,
            // delayOpenTimeUnit: 'Months',
            visibleTime: new Date().getTime()
        };
    }
    // 公有则遍历获取表单内容
    await formRef.value.validate();
    const res: ICategoryList = await Promise.all(
        // @ts-ignore
        categoryFormRef.value.map(item => item.getFormData())
    );
    const stsjItem = res.find(item => item.firstCategoryCode === 'zyzx_stsj');
    let params = {
        chooseCategoryList: res,
        // delayOpenTimeDuration: stsjItem?.delayOpenTimeDuration || 6,
        // delayOpenTimeUnit: 'Months',
        visibleTime: new Date().getTime()
    };
    // stsjItem && delete stsjItem.delayOpenTimeDuration;
    return params;
}

const handleConfirm = async () => {
    try {
        loading.value = true;
        const communityOpenInfo = await getParams();
        let params = {
            idList: [props.id],
            communityOpen: true,
            communityOpenInfo
        };
        console.log('params', params);
        await G_transmit('resourcePublish', {
            name: 'resourcePublish',
            data: params
        });
        Message({type: 'success', text: '您的资源已成功提交审核'});
        emit('success');
        handleCancel();
    } catch (error: any) {
        console.log('error', error);
        Message({
            type: 'info',
            text: error.message || error.status?.desc || '请将必填项填写完整'
        });
    }
    loading.value = false;
};

const handleCancel = () => {
    formRef.value.resetFields();
    emit('cancel');
};

// 获取默认列表
const getCommunityAssetCategory = async () => {
    try {
        const res = await G_transmit('getFilterCommunityAssetCategory', {
            queries: {
                tenant: props.tenant,
                brand: props.brand
            }
        });
        communityConfigData.value = res.data || [];
    } catch (error: any) {
        Message({type: 'info', text: error.message});
    }
};
</script>

<style lang="scss" scoped>
.community-wrapper {
    font-size: 14px;
}
.community-tip {
    display: flex;
    align-items: center;
    line-height: 22px;
    margin: 12px 0 0;
    padding: 6px 20px 6px 10px;
    border: 1px solid #ffefd9;
    background: #fff7eb;
    border-radius: 4px;
    color: #7a5f45;

    .info-icon {
        font-size: 18px;
        margin-right: 6px;
        color: #ff9201;
    }
}

.category-checkbox {
    display: flex;
    align-items: center;
    height: 59px;
    .form-label {
        width: 90px;
        color: var(--main-text-color);
    }

    .el-checkbox {
        margin-right: 20px;
    }
}

.community-form {
    /* padding-left: 30px; */
    /* height: 410px; */
}

.model-form-con {
    padding-bottom: 30px;

    :deep(.el-form-item__label) {
        padding-right: 20px;
        color: var(--color-gray);
        line-height: 40px;
        height: 40px;
    }

    &.overflow-model-form {
        /* height: calc(100% - 59px); */
        overflow-y: auto;
    }
}

.el-form-item {
    width: calc((100% - 60px) / 2);

    &:nth-child(2n + 1) {
        margin-right: 60px;
    }

    &.entire-line-item {
        width: 100%;
        margin-bottom: 8px;
        margin-right: 0;
    }
    &.form-item-nomarginbottom {
        margin-bottom: 0;
    }
}

.publish-input-con {
    // width: 100%;
    color: var(--main-text-color);

    .publish-time-input {
        width: 100px;
        margin: 0 10px;
    }
}

.publist-tip {
    color: var(--color-light-gray);
    font-size: 12px;
    padding-left: 4px;
}

.btn-con {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    .el-button + .el-button {
        margin-left: 20px;
    }
    .el-button {
        width: 76px;
    }
}
</style>
